<template>
  <div class="hvh-table-container">
    <v-card elevation="3" class="hvh-card--rounded">
      <slot name="table-heading" />
      <v-data-table :headers="headers" :items="tableData" :must-sort="true" :rows-per-page-items="rowsPerPage" hide-actions class="hvh-table">
        <template v-slot:items="props">
          <tr @click="$emit('table-row-click', props)" v-right-click-menu="`/Analytics/CohortAnalyticRun/${props.item.id}/Result`">
            <td class="hvh-table-cell--lg">
              <span class="hvh-table-cell--cohort-name">{{ props.item.name }}</span>
            </td>
            <td>
              <hvh-analysis-type-chip :type="props.item.type" :colors="analyticColors" />
            </td>
            <td>{{ props.item.creator }}</td>
            <td>
              <span class="hvh-date">{{ dateFormatter(props.item.createdDate) }}</span>
            </td>
            <td>
              <span class="hvh-date">{{ dateFormatter(props.item.lastRunDate) }}</span>
            </td>
            <td>
              <hvh-analysis-status-chip :status="props.item.status" />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['tableData', 'dateFormatter', 'analyticColors'],
  data() {
    return {
      rowsPerPage: [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }],
      headers: [
        {
          text: 'Cohort Name',
          value: 'name',
          align: 'left',
          sortable: false,
          class: ['hvh-table-header hvh-table-header--sm']
        },
        {
          text: 'Analysis Type',
          value: 'type',
          align: 'left',
          sortable: false,
          class: ['hvh-table-header hvh-table-header--sm']
        },
        {
          text: 'Creator',
          value: 'creator',
          align: 'left',
          sortable: false,
          class: ['hvh-table-header']
        },
        {
          text: 'Start Time',
          value: 'createdDate',
          sortable: false,
          class: ['hvh-table-header']
        },
        {
          text: 'Completed',
          value: 'lastRunDate',
          sortable: false,
          class: ['hvh-table-header']
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
          class: ['hvh-table-header']
        }
      ]
    };
  },
};
</script>

<style lang='scss'>
.hvh-table-cell--cohort-name {
  font-size: rem(16px);
  line-height: 1.125;
  font-weight: 600;
}

.hvh-table-cell--lg {
  width: 250px;
}

.hvh-toolbar--form .v-toolbar__content {
  margin: 15px 0 12px 0;
}
</style>
